<mat-form-field class="w-100" appearance="outline">
  <input
    matInput
    (blur)="onBlur()"
    (focus)="onFocus()"
    (keyup)="onKeyUp($event)"
    (change)="onChange($event)"

    [placeholder]="placeholder || ''"
    [value]="labelSelected || ''"
    [matAutocomplete]="auto"

    type="text"
    class="field-control {{errors?.length ? 'text-warning-500' : ''}}"
  />
  <mat-label [classList]="errors?.length ? ['text-warning-300'] : []">{{ label }}</mat-label>
  <mat-icon matSuffix>arrow_drop_down</mat-icon>
  @if (imageSelected) {
    <span matTextPrefix>
      <img class="option-image-selected" [src]="imageSelected" alt="{{labelSelected}}" />
    </span>
  }

  <mat-autocomplete #auto="matAutocomplete" >
    @if (isLoading) {
      <mat-option disabled="true">Cargando datos ...</mat-option>
    }
    @for (option of optionList; track option; let index = $index) {

      <mat-option [value]="option.label" (click)="onSelect(option)">
        <div class="flex align-item-center option-item text-black-500">
          @if (option.image) {
            <div class="flex-shrink-0 m-r-10">
              <img class="option-image" [src]="option.image" alt="{{option.label}}" />
            </div>
          }

          <div class="flex-grow-1 p-2" >
            {{ option.label }}

            @for (badge of option.badges; track badge) {
              <span class="badge m-l-5">{{ badge }}</span>
            }
          </div>
        </div>
      </mat-option>

    }
  </mat-autocomplete>


  <mat-hint class="error-hint">
    @for (error of errors; track error) {
      <span class="bg-warning-500 text-white">
        {{ error.message }}
      </span>
    }
  </mat-hint>


</mat-form-field>

